/*Sage Custom Code Start (Oct 2025)*/
/* created the delivery estimate javascript file */


document.addEventListener("DOMContentLoaded", async () => {
  const deliveryBlock = document.getElementById("delivery-estimate-block");
  const countrySelect = document.getElementById("country-select");

  if (!deliveryBlock || !countrySelect) return;

  const shippingOrigin = deliveryBlock.dataset.shippingOrigin?.trim();
  if (!shippingOrigin) return;

  // Hide delivery if product out of stock
  const productForm = document.querySelector("form[action*='/cart/add']");
  const addToCartButton = productForm?.querySelector("[type='submit']");

  async function isProductCompletelySoldOut() {
  try {
    const res = await fetch(window.location.pathname + '.js');
    const product = await res.json();

    // Check if ANY variant is available
    const hasAvailable = product.variants.some(variant => variant.available);

    return !hasAvailable;
  } catch (e) {
    console.warn('Product availability check failed', e);
    return false;
  }
}

async function checkIfSoldOut() {
  const isSoldOut = await isProductCompletelySoldOut();

  if (isSoldOut) {
    deliveryBlock.style.display = "none";
  } else {
    deliveryBlock.style.display = "";
  }
}

  // Delivery rules
  const deliveryTimes = {
    "United States": shippingOrigin === "Ships From USA" ? "2–5 Business Days" : "5–10 Business Days",
    "Albania": "11–14 Business Days",
    "Australia": "8–16 Business Days",
    "Austria": "10–16 Business Days",
    "Belgium": "8–14 Business Days",
    "Brazil": "16–29 Business Days",
    "Bulgaria": "9–14 Business Days",
    "Canada": "8–14 Business Days",
    "Croatia": "14–16 Business Days",
    "Cyprus": "14–16 Business Days",
    "Czech Republic": "12–14 Business Days",
    "Denmark": "12–14 Business Days",
    "Estonia": "14–16 Business Days",
    "France": "8–14 Business Days",
    "Germany": "8–14 Business Days",
    "Finland": "14–16 Business Days",
    "Greece": "14–16 Business Days",
    "Hungary": "10–16 Business Days",
    "Ireland": "10–12 Business Days",
    "Israel": "14–17 Business Days",
    "Italy": "8–14 Business Days",
    "Japan": "7–12 Business Days",
    "Latvia": "14–16 Business Days",
    "Lithuania": "14–16 Business Days",
    "Luxembourg": "12–14 Business Days",
    "Malta": "12–14 Business Days",
    "Mexico": "7–12 Business Days",
    "Morocco": "8–14 Business Days",
    "Netherlands": "8–14 Business Days",
    "New Zealand": "8–14 Business Days",
    "Nigeria": "15–20 Business Days",
    "Pakistan": "11–16 Business Days",
    "Poland": "9–14 Business Days",
    "Portugal": "11–18 Business Days",
    "Qatar": "14–19 Business Days",
    "Romania": "12–14 Business Days",
    "Saudi Arabia": "7–14 Business Days",
    "Singapore": "4–9 Business Days",
    "Slovakia": "12–14 Business Days",
    "Slovenia": "12–14 Business Days",
    "Spain": "9–14 Business Days",
    "Sweden": "11–16 Business Days",
    "United Arab Emirates": "9–16 Business Days",
    "United Kingdom": "4–14 Business Days",
  };

  // Helper: add business days
  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) added++;
    }
    return result;
  }

  // Compute formatted delivery date range
  function getDeliveryText(country) {
    const deliveryText = deliveryTimes[country] || "7–20 Business Days";
    const [minDays, maxDays] = deliveryText.split("–").map(n => parseInt(n));
    const today = new Date();
    const startDate = addBusinessDays(today, minDays);
    const endDate = addBusinessDays(today, maxDays);
    const options = { month: "short", day: "numeric" };
    return `${startDate.toLocaleDateString(undefined, options)} – ${endDate.toLocaleDateString(undefined, options)}`;
  }

  // Determine initial country (IP-based)
  let initialCountry = "United States"; // fallback
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (res.ok) {
      const data = await res.json();
      if (data.country_name && deliveryTimes[data.country_name]) {
        initialCountry = data.country_name;
      }
    }
  } catch (e) {
    console.warn("IP detection failed, using default country.");
  }

  // Set selector value
  countrySelect.value = initialCountry;

  // Render delivery pill
  if (!deliveryBlock.querySelector(".delivery-date")) {
    const pill = document.createElement("div");
    pill.className = "delivery-estimate";
    pill.style.display = "flex";
    pill.style.alignItems = "center";
    pill.style.gap = "4px";
    pill.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 32 32"><path fill="#000000" d="m29.92 16.61l-3-7A1 1 0 0 0 26 9h-3V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7a1 1 0 0 0-.08-.39ZM23 11h2.34l2.14 5H23ZM9 26a2 2 0 1 1 2-2a2 2 0 0 1-2 2Zm10.14-3h-6.28a4 4 0 0 0-7.72 0H4V8h17v12.56A4 4 0 0 0 19.14 23ZM23 26a2 2 0 1 1 2-2a2 2 0 0 1-2 2Zm5-3h-1.14A4 4 0 0 0 23 20v-2h5Z"/></svg>
      <span class="delivery-label">Get it by:</span>
      <span class="delivery-date">${getDeliveryText(initialCountry)}</span>
    `;
    deliveryBlock.appendChild(pill);

    await checkIfSoldOut();
  }

  // Update delivery on selector change
  countrySelect.addEventListener("change", (e) => {
    const dateSpan = deliveryBlock.querySelector(".delivery-date");
    if (dateSpan) dateSpan.textContent = getDeliveryText(e.target.value);
  });

document.addEventListener('change', () => {
  setTimeout(() => {
    checkIfSoldOut();
  }, 50);
});

  // Styles
  const style = document.createElement("style");
  style.textContent = `
    .delivery-estimate { font-size: 0.75rem; font-weight: 600; color: #1a1a1a; display: flex; align-items: center; white-space: nowrap; flex-shrink: 0; gap: 4px; margin-top:4px; }
    .delivery-estimate svg { display: none; white-space: nowrap; flex-shrink: 0; }
    .delivery-label {}
    .details__header { white-space: nowrap; flex-shrink: 0; }
    .delivery-date { font-weight: 700; text-transform: uppercase; }
    #country-select { width: 100%; padding: 5px 4px; border-radius: 2px; border: 1px solid #ccc; font-size: 0.6875rem; margin-top:4px; margin-bottom:12px; }
  `;
  document.head.appendChild(style);

deliveryBlock.style.visibility = "visible";
});